import React from 'react';
import { XAxis, YAxis, Tooltip } from 'recharts';
import { BarChart, Bar, PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { Row, Col } from '../ui-kit';

const PagersDashboard = ({ pagerStats }) => {
  const oapStatusColors = { unknown: '#777', up_to_date: '#28a745', pending_install: '#f89406' };
  const byOapStatus = Object.entries(pagerStats.oap_status).map(([key, value]) => ({
    name: I18n.t('classy_enum.mobile/pagers/oap_status')[key],
    value,
    fill: oapStatusColors[key]
  }));

  const byFirmware = Object.entries(pagerStats.firmware_version).map(([name, value]) => ({
    name,
    value
  }));

  const byLastSeenAt = Object.entries(pagerStats.last_seen_at).map((entry, index) => ({
    name: entry[0],
    value: entry[1],
    fill: ['#28a745', '#5bc0de', '#f89406', '#dc3545'][index]
  }));

  const generatePieChart = (header, data) => (
    <Col xs={12} sm={12} md={4} lg={4}>
      <h4>{header}</h4>
      <div style={{ width: '100%', height: 300 }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie dataKey="value" data={data} outerRadius={'60%'} label={entry => entry.name}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </Col>
  );

  const generateBarChart = (header, data) => (
    <Col xs={12} sm={12} md={4} lg={4}>
      <h4>{header}</h4>
      <div style={{ width: '100%', height: 300 }}>
        <ResponsiveContainer>
          <BarChart
            data={data}
            dataKey="value"
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }}
          >
            <XAxis dataKey={'name'} />
            <YAxis />
            <Tooltip />
            <Bar dataKey={'value'} fill="#777" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Col>
  );

  return (
    <Row>
      {generatePieChart(I18n.t('activerecord.attributes.mobile/pagers/pager.oap_status'), byOapStatus)}
      {generateBarChart(I18n.t('activerecord.attributes.mobile/pagers/pager.firmware_version'), byFirmware)}
      {generatePieChart(I18n.t('attributes.last_seen_at'), byLastSeenAt)}
    </Row>
  );
};

export default PagersDashboard;
